import { fetchWithAuth } from "./FetchWithAuth";
import { url } from "./url";

const base = `${String(url).replace(/\/+$/, "")}/api/promotions`;

async function request(path = "", options = {}) {
  const response = await fetchWithAuth(`${base}${path}`, {
    credentials: "include",
    headers: { "Content-Type": "application/json", ...(options.headers || {}) },
    ...options,
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data?.error || `Request failed ${response.status}`);
  }
  return data;
}

export const promotionsApi = {
  list: ({ status, program_id, course_id } = {}) => {
    const q = new URLSearchParams();
    if (status) q.set("status", status);
    if (program_id != null) q.set("program_id", String(program_id));
    if (course_id != null) q.set("course_id", String(course_id));
    return request(q.toString() ? `?${q.toString()}` : "");
  },
  create: (payload) => request("", { method: "POST", body: JSON.stringify(payload) }),
  update: (id, payload) => request(`/${id}`, { method: "PATCH", body: JSON.stringify(payload) }),
  submit: (id) => request(`/${id}/submit`, { method: "POST" }),
  approve: (id) => request(`/${id}/approve`, { method: "POST" }),
  reject: (id) => request(`/${id}/reject`, { method: "POST" }),
};

